'use strict';
var LeveragingTechnologyController = /** @class */ (function () {
    /*@ngInject*/
    function LeveragingTechnologyController($scope, EducationSubNavService) {
        this.headerContent = "The “one size fits all” model of practice management works about as well as the allopathic medical model for chronic disease. The truth is that you have the knowledge, vision and ability to grow the practice of your dreams by creating and implementing a customized system that addresses your practice needs. You just need to learn how to use the right tools and systems. We live in a time where technology has changed the marketing playing field. When you harness the power of the internet and learn to leverage your time and knowledge, you can generate a vast source of new patients and untapped revenue for your clinic.";
        $scope.$ctrl.value.selectedpageindex = 3;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
    }
    return LeveragingTechnologyController;
}());
export default LeveragingTechnologyController;
//# sourceMappingURL=leveraging-technology.controller.js.map